module.exports = __webpack_public_path__ + "static/media/power-75.a6c11920.svg";